import { FilterData } from 'path-shared/models/filter-data';
import { SortDirection } from '@angular/material';

export class BancCarreguesC60DetallFilter extends FilterData {
  id: number;
  codiCarrega: string;

  constructor(sortField: string, sortDir: SortDirection) {
    super(sortField, sortDir);
    this.id = null;
    this.codiCarrega = '';

    this.labels['id'] = this.i18n('Id');
    this.labels['codiCarrega'] = this.i18n('Codi càrrega');
  }
}
